module.exports = __webpack_public_path__ + "img/teacher5.158d7d3c.jpg";